<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-ad-commission-agreement-modal">
    <div class="modal-dialog" role="document">
      <LoadingSpinner v-if="loading"/>

      <div v-else class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Ad Commission Agreement
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.commission"
                name="commission"
                label="Commission"
                :error="getError('commission')"
            />

            <SelectFormGroup
                v-model="channel"
                name="channel_id"
                label="Channel"
                :error="getError('channel')"
                :options="channelOptions"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {LoadingSpinner, SelectFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    user: {
      required: true
    }
  },

  data() {
    return {
      data: {},
      channel: null,

      loading: true,

      channels: null
    }
  },

  mounted() {
    this.load()

    this.listenForClose()
  },

  computed: {
    channelOptions() {
      return this.channels.map(channel => {
            return {
              value: JSON.stringify({type: channel.type, id: channel.id.toString()}),
              label: channel.name + ' (' + channel.portal.name + ')'
            }
          })
          .sort((a, b) => a.label < b.label ? -1 : 1)
    }
  },

  methods: {
    load() {
      http.get('/api/v1/channels').then(response => {
        this.channels = response.data.data

        this.loading = false
      })
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if(!this.channel) {
        this.errors = {channel: ['The channel field is required.']}

        return
      }

      http.post('/api/v2/ad-commission-agreements', {
        ...this.data,
        user_id: this.user.id,
        channel_type: JSON.parse(this.channel).type,
        channel_id: JSON.parse(this.channel).id,
      })
          .then(response => {
            notify.success('The ad commission agreement was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
